import '../scss/pfields/Ptextarea.scoped.scss';
import {useState} from "react";

function Ptextarea({pfield}) {
  let tol = pfield.obj.querySelector('textarea');
  const [value, setValue] = useState(tol.value);
  let sid = "r" + pfield.id;
  let lol = pfield.obj.querySelector('label').textContent;
  let classes = ["pfield"];
  if(pfield.dependent) {
    classes.push("hidden");
  }
  if(pfield.error) {
    classes.push("error");
  }
  classes = classes.concat(pfield.eclasses);
  const updatePardot = (e) => {
    let f = e.target;
    let o = [...document.querySelectorAll("#p-content textarea")]
      .filter(
        (c) => c.name === f.name.substring(1)
      )[0];
    if(o) {
      o.value = f.value
    } else {
      console.log(">>> " + f.name);
    }
    setValue(e.target.value);
  }
  return(
    <div className={classes.join(' ')} id={'d' + pfield.id}>
      {pfield.error ? <p>{pfield.errtxt}</p> : "" }
      <textarea id={sid} name={sid} placeholder={lol} value={value} onChange={updatePardot}/>
    </div>
  );

}

export default Ptextarea;